import { ObjOrVoid } from '../../../../typescript';
import { fetcher } from '../../fetcher';
import { HttpMethod } from '../../http-method';
import { UserAgent } from '../../user-agent';

import { BuildEndpointOpts, FetchEndpoint, PrepareFetcher, QueryFn } from './build-endpoint.model';
import { flow, getBaseUrl, makeSearchParams } from './build-endpoint.utils';

const buildEndpoint = <EndpointResponse = any, RequestArgs extends ObjOrVoid = void>({
    baseUrl = 'research-api',
    cachePrefix,
    query,
    queryFn,
    useResearchApiV2Mapper,
}: BuildEndpointOpts<EndpointResponse, RequestArgs>) => {
    const prepareFetcher: PrepareFetcher<RequestArgs> = ({
        uri,
        params,
        unencodedParams,
        options = {},
        overrideBaseUrl,
    }) => {
        const base = getBaseUrl(baseUrl, overrideBaseUrl);
        let url = `${base}${uri}`;

        const search = makeSearchParams(params, unencodedParams, baseUrl, useResearchApiV2Mapper);

        if (search) {
            url += search;
        }

        return { url, baseUrl: overrideBaseUrl ?? baseUrl, useResearchApiV2Mapper, ...options };
    };

    let fetchEndpoint: any;

    // initialize endpoint
    if (queryFn) {
        const prepareQueryFn = (requestArgs: RequestArgs) => [requestArgs, { baseFetch: fetcher }];
        fetchEndpoint = flow(prepareQueryFn, queryFn);
    } else {
        fetchEndpoint = flow(query, prepareFetcher, fetcher);
    }

    // attach cache prefix to endpoint
    fetchEndpoint.cachePrefix = cachePrefix;

    return fetchEndpoint as FetchEndpoint<EndpointResponse, RequestArgs>;
};

buildEndpoint.Method = HttpMethod;
buildEndpoint.UserAgent = UserAgent;

type BuildEndpoint = typeof buildEndpoint;

export type { ObjOrVoid, FetchEndpoint, QueryFn, BuildEndpoint };
export { buildEndpoint };
